import { React, useState, useEffect } from 'react'
import Input from '../input/Input'
import { useSelector, useDispatch } from 'react-redux'
import { language } from '../../stores/slices/languageSlice'
import DateInput from '../input/Date'
import validateInput from '../../utilities/validations/validateInput';
import { toast } from "react-toastify";
import { searchPartnerPatient, setStoreSearchPatientDetails, setStoreInitialSearch, setStoreDisplayPatientCard, setStoreCreateNewPatientModal, createPatientInPartner, resetPatientSearch, IsPatientLockedReset } from '../../stores/slices/patientSearch/patientSearchSlice'
import { Modal } from 'antd'
import { DROPDOWN_STATES, PARTNER_AUTH, PARTNER_BROWSER_ID } from '../../constant/Constants';
import { smartyStreetApi } from '../../stores/slices/smartyStreetSlice';
import { lookUp } from '../../stores/slices/lookupSlice'
import maskData from '../../utilities/validations/maskData'
import Loader from '../menu/Loader'
import { resetFundLists } from '../../stores/slices/preQual/preQualFundsListSlice'
import { resetPreQualQuestions } from '../../stores/slices/preQual/preQualQuestionsSlice'
import { resetPreQualSubmitData } from '../../stores/slices/preQual/preQualValidateSlice'
import { resetTreatingPhysician } from '../../stores/slices/appIntake/searchProviderSlice'
import { resetClaimIntakeData } from '../../stores/slices/claimIntake/claimIntakeSlice'
import { resetPatientApplication } from '../../stores/slices/patientSearch/patientApplicationListSlice'
import { getAllSessions } from '../../utilities/API/supertokenServices'
import { resetPatientCaseList } from '../../stores/slices/caseManagement/patientCaseListSlice'

function SearchPatient({ value }) {

    const dispatch = useDispatch();

    // language & content from the store
    const selectedLanguage = useSelector(language).PatientSearch.searchPatient;
    const createPatientLanguage = useSelector(language).PatientSearch.createPatient;
    const errorMessage = useSelector(language).errorMessage;
    const loginData = useSelector((state) => state.loginSlice);
    const sessionData = useSelector((state) => state.sessionSlice)
    const preAuth = useSelector((state) => state.preAuthSlice);
    const generalConfig = useSelector((state) => state.generalConfigSlice);
    const searchPatientStore = useSelector((state) => state.patientSearchSlice);
    const lookUpData = useSelector(lookUp);

    // Intial state for patient search fields
    const [searchPatient, setSearchPatient] = useState({
        firstName: {
            value: '',
            isValid: true,
        },
        lastName: {
            value: '',
            isValid: true,
        },
        dob: {
            value: '',
            isValid: true
        },
        ssn: {
            value: '',
            isValid: true
        },
        alienNumber: {
            value: '',
            isValid: true
        },


    })

    // Initial State for Create Patient
    const [createPatientState, setCreatePatientState] = useState(
        {
            addressLine1: {
                value: '',
                isValid: true,
            },
            addressLine2: {
                value: '',
                isValid: true,
            },
            city: {
                value: '',
                isValid: true,
            },
            state: {
                value: '',
                isValid: true,
            },
            zipCode: {
                value: '',
                isValid: true,
            },
            phoneNumber: {
                value: '',
                isValid: true,
                errorMsg: false
            },
            email: {
                value: '',
                isValid: true,
            },
            smartyStreetMatches: {
                NoMatch: false,
                PartialMatch: false,
                SecInfoNotMatch: false,
                ExactMatch: false,
            },
            ss_msg_cls: '',
            ss_msg: '',
            isAddressVerified: false,
        }

    )

    const [allowCreatePatient, setAllowCreatePatient] = useState(true);
    // Remove Patient Card When Component Mount
    useEffect(() => {
        dispatch(resetFundLists())
        dispatch(resetPreQualQuestions())
        dispatch(resetPreQualSubmitData())
        dispatch(resetTreatingPhysician())
        dispatch(resetPatientSearch())
        dispatch(resetClaimIntakeData())
        searchPatientStore.displayPatientCard && dispatch(setStoreDisplayPatientCard(false));
    }, [])

    // reset Create patient state when modal close
    const resetCreatePatientState = () => {
        setCreatePatientState((prevState) => ({
            ...prevState,
            addressLine1: {
                value: '',
                isValid: true,
            },
            addressLine2: {
                value: '',
                isValid: true,
            },
            city: {
                value: '',
                isValid: true,
            },
            state: {
                value: '',
                isValid: true,
            },
            zipCode: {
                value: '',
                isValid: true,
            },
            phoneNumber: {
                value: '',
                isValid: true,
                errorMsg: false
            },
            email: {
                value: '',
                isValid: true,
            },
            smartyStreetMatches: {
                NoMatch: false,
                PartialMatch: false,
                SecInfoNotMatch: false,
                ExactMatch: false,
            },
            ss_msg_cls: '',
            ss_msg: '',
            isAddressVerified: false,

        }));
        setAllowCreatePatient(true);
    }



    // Input onChange validation
    const inputOnChange = (e, fieldValidation) => {

        let inputValue = e.target.value;
        let inputName = e.target.name;

        // Feild level validation
        let inputValidate = validateInput(inputValue, fieldValidation);

        // Updating the onChange input values to the respective state
        setSearchPatient((prevState) => ({
            ...prevState,
            [inputName]: {
                value: inputValidate.value,
                isValid: inputValidate.isValid
            }
        }))

        // If user iput value on (SSN / Alien number) on their respective fields we need to clear the data on the (SSN / Alien number)
        if (inputName == 'ssn' || inputName == 'alienNumber') {
            let resetData = inputName != 'ssn' ? 'ssn' : 'alienNumber';
            setSearchPatient((prevState) => ({
                ...prevState,
                [resetData]: {
                    value: '',
                    isValid: true
                }
            }))
        } else if (inputName == 'firstName' || inputName == 'lastName') {
            setSearchPatient((prevState) => ({
                ...prevState,
                dob: {
                    value: searchPatient.dob.value,
                    isValid: (searchPatient.dob.value == '' && searchPatient.dob.isValid == false) ? true : searchPatient.dob.isValid
                },
                ssn: {
                    value: searchPatient.ssn.value,
                    isValid: (searchPatient.ssn.value == '' && searchPatient.ssn.isValid == false) ? true : searchPatient.ssn.isValid
                },
                alienNumber: {
                    value: searchPatient.alienNumber.value,
                    isValid: (searchPatient.alienNumber.value == '' && searchPatient.alienNumber.isValid == false) ? true : searchPatient.alienNumber.isValid
                }
            }))
        }

        // Remove patient card if the patient changes the data
        searchPatientStore.displayPatientCard && dispatch(setStoreDisplayPatientCard(false));
    }

    // Input onChange Create Patient
    const inputOnChangeCreatePatient = (e, fieldValidation) => {

        let inputValue = e.target.value;
        let inputName = e.target.name;

        // Feild level validation
        let inputValidate = validateInput(inputValue, fieldValidation);
        // Updating the onChange input values to the respective state
        if (inputName == "phoneNumber") {
            setCreatePatientState((prevState) => ({
                ...prevState,
                [inputName]: {
                    value: inputValidate.value,
                    isValid: inputValidate.isValid,
                    errorMsg: inputValidate.errorMsg
                }
            }))
        } else if (inputName == "email") {
            setCreatePatientState((prevState) => ({
                ...prevState,
                [inputName]: {
                    value: inputValidate.value,
                    isValid: inputValue.length > 0 ? inputValidate.isValid : true
                }
            }))
        } else {
            setCreatePatientState((prevState) => ({
                ...prevState,
                [inputName]: {
                    value: inputValidate.value,
                    isValid: inputValidate.isValid
                }
            }))
        }
        // reseting samrty street related state when any changes happens to the address fields
        if (inputName == 'addressLine1' || inputName == 'addressLine2' || inputName == 'city' || inputName == 'state' || inputName == 'zipCode') {
            setCreatePatientState((prevState) => ({
                ...prevState,
                smartyStreetMatches: {
                    NoMatch: false,
                    PartialMatch: false,
                    SecInfoNotMatch: false,
                    ExactMatch: false,
                },
                ss_msg_cls: '',
                ss_msg: '',
                isAddressVerified: false,
            }))
        }
    }

    // If Additional Data needed higlight the fields updating function
    const additionalDataForSearch = () => {
        setSearchPatient((prevState) => ({
            ...prevState,
            firstName: {
                value: searchPatient.firstName.value,
                isValid: searchPatient.firstName.isValid && searchPatient.firstName.value != ''
            },
            lastName: {
                value: searchPatient.lastName.value,
                isValid: searchPatient.lastName.isValid && searchPatient.lastName.value != ''
            },
            dob: {
                value: searchPatient.dob.value,
                isValid: searchPatient.dob.isValid && searchPatient.dob.value != ''
            },
            ssn: {
                value: searchPatient.ssn.value,
                isValid: searchPatient.ssn.isValid && (searchPatient.ssn.value != '' || searchPatient.alienNumber.value != '')
            },
            alienNumber: {
                value: searchPatient.alienNumber.value,
                isValid: searchPatient.alienNumber.isValid && (searchPatient.alienNumber.value != '' || searchPatient.ssn.value != '')
            }
        }))

        dispatch(setStoreInitialSearch(true));
    }

    // If Additional Data needed higlight the fields
    !searchPatientStore.initialSearch && additionalDataForSearch();



    // Patient search over all validation & Intiate the patient search 
    const onSearchPatient = () => {
        dispatch(resetPatientApplication())
        dispatch(resetPatientCaseList())
        dispatch(setStoreDisplayPatientCard(false))
        // first criteria search (first name & last name are the mandatory fields)
        if ((searchPatient.firstName.value != '' && searchPatient.firstName.isValid == true) &&
            (searchPatient.lastName.value != '' && searchPatient.lastName.isValid == true) &&
            (searchPatient.dob.isValid == true) && (searchPatient.alienNumber.isValid == true) && (searchPatient.ssn.isValid == true)) {
            let data = {
                isSSN: searchPatient.ssn.value != '' ? true : false,
                firstName: searchPatient.firstName.value,
                lastName: searchPatient.lastName.value,
                dob: searchPatient.dob.value != '' ? `${searchPatient.dob.value.substring(5, 7)}/${searchPatient.dob.value.substring(8, 10)}/${searchPatient.dob.value.substring(0, 4)}` : '',
                ssn: searchPatient.ssn.value,
                alienNumber: searchPatient.alienNumber.value,
                maskedAlien: maskData('Alien', searchPatient.alienNumber.value),
                maskedSSN: maskData('SSN', searchPatient.ssn.value),
            }

            // Storing Patient search data 
            dispatch(setStoreSearchPatientDetails(data));

            // PATIENT SEARCH API CALLING

                    dispatch(
                        searchPartnerPatient({
                            BrowserId: PARTNER_BROWSER_ID.ID,
                            data: searchPatient,
                            EIN: loginData.value.EIN,
                            authorization: PARTNER_AUTH,
                            prgData: generalConfig.PARTNER,
                        })
                    )


            resetCreatePatientState();

        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
            setSearchPatient((prevState) => ({
                ...prevState,
                firstName: {
                    value: searchPatient.firstName.value,
                    isValid: searchPatient.firstName.isValid && searchPatient.firstName.value != ''
                },
                lastName: {
                    value: searchPatient.lastName.value,
                    isValid: searchPatient.lastName.isValid && searchPatient.lastName.value != ''
                }
            }))
        }


    }

    // Create Patient Modal Cancel
    const onClickCreatePatientModalCancel = () => {
        setCreatePatientState((prevState) => ({
            addressLine1: {
                value: '',
                isValid: true,
            },
            addressLine2: {
                value: '',
                isValid: true,
            },
            city: {
                value: '',
                isValid: true,
            },
            state: {
                value: '',
                isValid: true,
            },
            zipCode: {
                value: '',
                isValid: true,
            },
            phoneNumber: {
                value: '',
                isValid: true,
                errorMsg: false
            },
            email: {
                value: '',
                isValid: true,
            },
            smartyStreetMatches: {
                NoMatch: false,
                PartialMatch: false,
                SecInfoNotMatch: false,
                ExactMatch: false,
            },
            ss_msg_cls: '',
            ss_msg: '',
            isAddressVerified: false,

        }));
        setAllowCreatePatient(true);
        dispatch(setStoreCreateNewPatientModal(false));


    }

    // Create Patient Modal Submit
    const onClickCreatePatientModalSubmit = () => {
        if (createPatientState.addressLine1.value != '' && createPatientState.addressLine1.isValid &&
            createPatientState.city.value != '' && createPatientState.city.isValid &&
            createPatientState.state.value != '' && createPatientState.state.isValid &&
            createPatientState.zipCode.value != '' && createPatientState.zipCode.isValid &&
            createPatientState.isAddressVerified && createPatientState.addressLine2.isValid &&
            createPatientState.phoneNumber.value != '' && createPatientState.phoneNumber.isValid && allowCreatePatient) {
            // Create Patient API Call
            let data = {
                "PortalUserDetails": {
                    "EmailAddress": loginData.value.EmailAddress,
                    "PortalType": "Partner",
                    "ReferenceID": `E-${loginData.value.EIN}`,
                    PortalUserID: loginData.value.PortalUserID,
                    "SubmissionChannel": "Partner"
                },
                "PartnerPatient": {
                    "DateOfBirth": searchPatientStore.searchPatientDetails.dob,
                    "SocialSecurityNumber": searchPatientStore.searchPatientDetails.ssn,
                    "SocialSecurityNumber_Input": searchPatientStore.searchPatientDetails.ssn,
                    "AlienNumber_Input": searchPatientStore.searchPatientDetails.alienNumber,
                    "AlienNumber": searchPatientStore.searchPatientDetails.alienNumber,
                    "pxObjClass": "PAF-Data-PartnerPatient",
                    "PrimaryEmail": createPatientState.email.value,
                    "pyFirstName": searchPatientStore.searchPatientDetails.firstName,
                    "pyLastName": searchPatientStore.searchPatientDetails.lastName,
                    "Address": [
                        {
                            "AddressLine1": createPatientState.addressLine1.value,
                            "AddressLine2": createPatientState.addressLine2.value,
                            "City": createPatientState.city.value,
                            "Country": "US",
                            "pxObjClass": "Embed-PegaHC-Address",
                            "State": createPatientState.state.value,
                            "Type": "Home",
                            "ZipCode": createPatientState.zipCode.value,
                            "IsVerified": "true",
                            "IsValid": true,
                            "NoMatch": createPatientState.smartyStreetMatches.NoMatch,
                            "PartialMatch": createPatientState.smartyStreetMatches.PartialMatch,
                            "ExactMatch": createPatientState.smartyStreetMatches.ExactMatch,
                            "SecInfoNotMatch": createPatientState.smartyStreetMatches.SecInfoNotMatch
                        }
                    ],

                    "PhoneCommunication": [
                        {
                            "IsPrimary": "true",
                            "PhoneNumber": createPatientState.phoneNumber.value,
                            "pxObjClass": "Embed-PegaHC-Communication-Phone"
                        }
                    ]


                },
                "SubmissionChannel": "Partner"
            }
            setAllowCreatePatient(false);
                dispatch(createPatientInPartner({
                    reqBody: data,
                    browserId: PARTNER_BROWSER_ID.ID,
                    portalUserId: loginData.value.PortalUserID,
                    prgData: 'PARTNER'
                }))



        } else {
            setCreatePatientState((prevState) => ({
                ...prevState,
                isAddressVerified: prevState.isAddressVerified,
                addressLine1: {
                    value: prevState.addressLine1.value,
                    isValid: prevState.addressLine1.isValid && prevState.addressLine1.value != '',
                },
                addressLine2: {
                    value: prevState.addressLine2.value,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: prevState.city.value,
                    isValid: prevState.city.isValid && prevState.city.value != '',
                },
                state: {
                    value: prevState.state.value,
                    isValid: prevState.state.isValid && prevState.state.value != '',
                },
                zipCode: {
                    value: prevState.zipCode.value,
                    isValid: prevState.zipCode.isValid && prevState.zipCode.value != '',
                },
                phoneNumber: {
                    value: prevState.phoneNumber.value,
                    isValid: prevState.phoneNumber.isValid && prevState.phoneNumber.value != '',
                },
                email: {
                    value: prevState.email.value,
                    isValid: prevState.email.isValid,
                }
            }));

            if (!createPatientState.isAddressVerified) {
                toast.error(errorMessage.verifyAddressError);
            }
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)

        }

    }


    // SmartyStreet Verify Address

    const onClickVerifyAddress = () => {
        if (createPatientState.addressLine1.value != '' && createPatientState.addressLine1.isValid &&
            createPatientState.city.value != '' && createPatientState.city.isValid &&
            createPatientState.state.value != '' && createPatientState.state.isValid &&
            createPatientState.zipCode.value != '' && createPatientState.zipCode.isValid &&
            createPatientState.addressLine2.isValid) {
            let address = {
                addressLine1: createPatientState.addressLine1.value,
                addressLine2: createPatientState.addressLine2.value,
                city: createPatientState.city.value,
                state: createPatientState.state.value,
                zipCode: createPatientState.zipCode.value,
            };
            dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
            setCreatePatientState((prevState) => ({
                ...prevState,
                isAddressVerified: prevState.isAddressVerified,
                addressLine1: {
                    value: prevState.addressLine1.value,
                    isValid: prevState.addressLine1.isValid && prevState.addressLine1.value != '',
                },
                addressLine2: {
                    value: prevState.addressLine2.value,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: prevState.city.value,
                    isValid: prevState.city.isValid && prevState.city.value != '',
                },
                state: {
                    value: prevState.state.value,
                    isValid: prevState.state.isValid && prevState.state.value != '',
                },
                zipCode: {
                    value: prevState.zipCode.value,
                    isValid: prevState.zipCode.isValid && prevState.zipCode.value != '',
                }
            }));
        }
    }

    const callbackVerifiedAddress = (address) => {
        if (address?.isValidateAddress != undefined && address.isValidateAddress == "ExactMatch") {
            setCreatePatientState((prevState) => ({
                ...prevState,
                isAddressVerified: prevState.isAddressVerified,
                addressLine1: {
                    value: address.street,
                    isValid: prevState.addressLine1.isValid,
                },
                addressLine2: {
                    value: address.street2,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: address.city,
                    isValid: prevState.city.isValid,
                },
                state: {
                    value: address.state,
                    isValid: prevState.state.isValid,
                },
                zipCode: {
                    value: address.zipcode,
                    isValid: prevState.zipCode.isValid,
                },
                smartyStreetMatches: {
                    NoMatch: address.NoMatch,
                    PartialMatch: address.PartialMatch,
                    SecInfoNotMatch: address.SecInfoNotMatch,
                    ExactMatch: address.ExactMatch,
                },
                ss_msg_cls: "ss_success",
                ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
                isAddressVerified: true,
            }));

        } else {
            setCreatePatientState((prevState) => ({
                ...prevState,
                addressLine1: {
                    value: address.street,
                    isValid: prevState.addressLine1.isValid,
                },
                addressLine2: {
                    value: address.street2,
                    isValid: prevState.addressLine2.isValid,
                },
                city: {
                    value: address.city,
                    isValid: prevState.city.isValid,
                },
                state: {
                    value: address.state,
                    isValid: prevState.state.isValid,
                },
                zipCode: {
                    value: address.zipcode,
                    isValid: prevState.zipCode.isValid,
                },
                smartyStreetMatches: {
                    NoMatch: address.NoMatch,
                    PartialMatch: address.PartialMatch,
                    SecInfoNotMatch: address.SecInfoNotMatch,
                    ExactMatch: address.ExactMatch,
                },
                ss_msg_cls: "ss_error",
                ss_msg: errorMessage.smartyStreetMsg.errorMsg,
                isAddressVerified: true,


            }));
        }
    }



    // Patient search 
    return (
        <div className="py-1 py-sm-4 ">

            {/* Header section */}
            <div className="d-flex justify-content-center">
                <div className="px-5 mt-1">
                    <div className="fw-medium text-center fs-lg">{value && selectedLanguage.heading}</div>
                </div>
            </div>

            {/* Patient search section */}
            <div className="px-5 px-sm-20 mt-4 ">
                <div className="fw-medium fs-base mt-10"> <p className="p-1 ps-3 text-theme-1" >{selectedLanguage.patientDetails}</p></div>
                <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                    <div className="intro-y g-col-12 g-col-sm-4">
                        <Input
                            id="firstName"
                            name='firstName'
                            type="text"
                            label={selectedLanguage.firstName}
                            value={searchPatient.firstName.value}
                            isValid={searchPatient.firstName.isValid}
                            errorMsg={errorMessage.inputErrorMessage}
                            onChange={(e) => inputOnChange(e, 'firstName')}
                            maxLength='30'
                        />
                    </div>
                    <div className="intro-y g-col-12 g-col-sm-4">
                        <Input
                            id="lastName"
                            type="text"
                            name="lastName"
                            label={selectedLanguage.lastName}
                            value={searchPatient.lastName.value}
                            isValid={searchPatient.lastName.isValid}
                            errorMsg={errorMessage.inputErrorMessage}
                            onChange={(e) => inputOnChange(e, 'lastName')}
                            maxLength='30'
                        />
                    </div>
                    <div className="intro-y g-col-12 g-col-sm-4">
                        <DateInput
                            id="dob"
                            name="dob"
                            label={selectedLanguage.DOB}
                            value={searchPatient.dob.value}
                            isValid={searchPatient.dob.isValid}
                            errorMsg={errorMessage.inputErrorMessage}
                            onChange={(e) => inputOnChange(e, 'dob')}
                        />
                    </div>
                    <div className="intro-y g-col-12 g-col-sm-4">
                        <Input
                            id="ssn"
                            type="text"
                            name="ssn"
                            label={selectedLanguage.SSN}
                            value={searchPatient.ssn.value}
                            isValid={searchPatient.ssn.isValid}
                            errorMsg={errorMessage.inputErrorMessage}
                            onChange={(e) => inputOnChange(e, 'ssn')}
                            maxLength='11'
                        />
                    </div>
                    <div className="intro-y g-col-12 g-col-sm-4">
                        <Input
                            id="alienNumber"
                            type="text"
                            name="alienNumber"
                            label={selectedLanguage.AlienNumber}
                            value={searchPatient.alienNumber.value}
                            isValid={searchPatient.alienNumber.isValid}
                            errorMsg={errorMessage.inputErrorMessage}
                            onChange={(e) => inputOnChange(e, 'alienNumber')}
                            maxLength='10'
                        />
                    </div>

                    {/* Patient search button */}
                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                        <button className="btn btn-yellow w-24 ms-2" onClick={onSearchPatient}>{selectedLanguage.search} </button>
                    </div>
                </div>
            </div>

            {/* Create patient Modal Pop-up */}
            <Modal
                open={searchPatientStore.createNewPatientModal}
                title=''
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
                className='myModal'
                maskClosable={false}
                closable={false}
                width={1000}
                centered
            >
                {!allowCreatePatient && <Loader />}
                {/* Patient Creation section */}
                {/* Header section */}
                {/* {searchPatientStore.createNewPatientModal && resetCreatePatientState()} */}
                <div className='modal_style'>
                    <div className="d-flex justify-content-center">
                        <div className="px-5 mt-1">
                            <div className="fw-medium text-center fs-lg text-theme-1">{createPatientLanguage.createPatientHeading}</div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center px-5 px-sm-20">
                        <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                            <div className="intro-y g-col-12 g-col-sm-6">
                                <div className="d-flex flex-column justify-content-center align-items-center align-items-lg-start mt-4">
                                    <div className="truncate white-space-sm-normal d-flex align-items-center fw-medium fs-base ">{selectedLanguage.firstName} <div className="text-gray-600 px-2">{searchPatientStore.searchPatientDetails.firstName}</div></div>
                                    <div className="truncate white-space-sm-normal d-flex align-items-center mt-3 fw-medium fs-base ">{selectedLanguage.lastName}<div className="text-gray-600 px-2">{searchPatientStore.searchPatientDetails.lastName}</div></div>
                                </div>
                            </div>
                            <div className="intro-y g-col-12 g-col-sm-6">
                                <div className="d-flex flex-column justify-content-center align-items-center align-items-lg-start mt-4">
                                    <div className="truncate white-space-sm-normal d-flex align-items-center fw-medium fs-base ">{selectedLanguage.DOB}<div className="text-gray-600 px-2">{searchPatientStore.searchPatientDetails.dob}</div></div>
                                    <div className="truncate white-space-sm-normal d-flex align-items-center mt-3 fw-medium fs-base ">{searchPatientStore.searchPatientDetails.isSSN ? selectedLanguage.SSN : selectedLanguage.AlienNumber}<div className="text-gray-600 px-2">{searchPatientStore.searchPatientDetails.isSSN ? searchPatientStore.searchPatientDetails.maskedSSN : searchPatientStore.searchPatientDetails.maskedAlien}</div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="px-5 px-sm-20 mt-4 ">
                        <div className="fw-medium fs-base mt-10"> <p className="p-1 ps-3 text-theme-1" >{createPatientLanguage.addresInfo}</p></div>
                        <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="addressLine1"
                                    name='addressLine1'
                                    type="text"
                                    label={createPatientLanguage.addressLine1}
                                    value={createPatientState.addressLine1.value}
                                    isValid={createPatientState.addressLine1.isValid}
                                    errorMsg={errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'address')}
                                    maxLength='100'
                                />
                            </div>
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="addressLine2"
                                    type="text"
                                    name="addressLine2"
                                    label={createPatientLanguage.addressLine2}
                                    value={createPatientState.addressLine2.value}
                                    isValid={createPatientState.addressLine2.isValid}
                                    errorMsg={errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'addressLine2')}
                                    maxLength='100'
                                />
                            </div>
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="city"
                                    type="text"
                                    name="city"
                                    label={createPatientLanguage.city}
                                    value={createPatientState.city.value}
                                    isValid={createPatientState.city.isValid}
                                    errorMsg={errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'city')}
                                    maxLength='50'
                                />
                            </div>
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="state"
                                    type="select"
                                    name="state"
                                    label={createPatientLanguage.state}
                                    value={createPatientState.state.value}
                                    isValid={createPatientState.state.isValid}
                                    errorMsg={errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'state')}
                                    elmentconfig={lookUpData.State}
                                    maxLength='11'
                                />
                            </div>
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="zipCode"
                                    type="text"
                                    name="zipCode"
                                    label={createPatientLanguage.zipCode}
                                    value={createPatientState.zipCode.value}
                                    isValid={createPatientState.zipCode.isValid}
                                    errorMsg={errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'zipcode')}
                                    maxLength='5'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <div className="px-5 mt-4">
                            <div className={`${createPatientState.ss_msg_cls} p-3`}>
                                {createPatientState.ss_msg}
                            </div>
                            <button className="btn btn-yellow w-40 ms-2" onClick={onClickVerifyAddress}>{createPatientLanguage.verifyAddress}</button>
                        </div>
                    </div>
                    <div className="px-5 px-sm-20 mt-4 ">
                        <div className="fw-medium fs-base mt-10"> <p className="p-1 ps-3 text-theme-1" >{createPatientLanguage.communicationInfo}</p></div>
                        <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="phoneNumber"
                                    name='phoneNumber'
                                    type="text"
                                    maxLength="12"
                                    label={createPatientLanguage.phoneNumber}
                                    value={createPatientState.phoneNumber.value}
                                    isValid={createPatientState.phoneNumber.isValid}
                                    errorMsg={createPatientState.phoneNumber.errorMsg ? "Phone/Fax number cannot begin with the number one" : errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'phoneNumber')}
                                />
                            </div>
                            <div className="intro-y g-col-12 g-col-sm-4">
                                <Input
                                    id="email"
                                    type="text"
                                    name="email"
                                    label={createPatientLanguage.email}
                                    value={createPatientState.email.value}
                                    isValid={createPatientState.email.isValid}
                                    errorMsg={errorMessage.inputErrorMessage}
                                    onChange={(e) => inputOnChangeCreatePatient(e, 'email')}
                                    maxLength='100'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                        <button className="btn btn-secondary w-24 ms-2" onClick={onClickCreatePatientModalCancel}>{createPatientLanguage.cancelBtn} </button>
                        <button className="btn btn-yellow w-24 ms-2" onClick={onClickCreatePatientModalSubmit}>{createPatientLanguage.submitBtn} </button>
                    </div>
                </div>
            </Modal>
        </div>

    )
}

export default SearchPatient